var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "openrouter-channels" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: _vm.$t("message.integrations"), route: "integrations" },
            { title: _vm.providerInfo.name },
          ],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "page-content" }, [
        _c("div", { staticClass: "provider-header" }, [
          _c("div", { staticClass: "provider-logo" }, [
            _c("img", {
              attrs: { src: _vm.providerInfo.logo, alt: _vm.providerInfo.name },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "provider-info" }, [
            _c("h1", [_vm._v(_vm._s(_vm.providerInfo.name))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.providerInfo.description))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "channels-section" }, [
          _c(
            "div",
            { staticClass: "section-header" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("message.channels") || "Kanallar")),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showCreateModal = true
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("add"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("whatsappChannel.addChannel") || "Kanal Ekle"
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.providerChannels.length > 0
            ? _c(
                "div",
                { staticClass: "channels-grid" },
                _vm._l(_vm.providerChannels, function (channel) {
                  return _c(
                    "div",
                    {
                      key: channel._id,
                      staticClass: "channel-card",
                      on: {
                        click: function ($event) {
                          return _vm.editChannel(channel)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", { staticClass: "channel-icon" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.providerInfo.logo,
                              alt: _vm.providerInfo.name,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "channel-status",
                            class: { enabled: channel.enabled },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  channel.enabled
                                    ? _vm.$t("auto.active")
                                    : _vm.$t("auto.inactive")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "channel-name" }, [
                          _vm._v(_vm._s(channel.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "channel-meta" }, [
                          _c("span", { staticClass: "key-mode" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("vpn_key"),
                            ]),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  channel.payload.keyMode === "byok"
                                    ? "BYOK"
                                    : "Supsis"
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-actions" },
                        [
                          _c(
                            "a-dropdown",
                            {
                              attrs: {
                                trigger: ["click"],
                                placement: "bottomRight",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a-menu",
                                          [
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copyChannelId(
                                                      channel._id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("content_copy")]
                                                ),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.copyChannelID"
                                                      ) || "Channel ID Kopyala"
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.confirmDelete(
                                                      channel
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                    staticStyle: {
                                                      color: "#f5222d",
                                                    },
                                                  },
                                                  [_vm._v("delete")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#f5222d",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chatbotv2.delete"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("more_vert")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("message.noChannels") || "Henüz kanal yok")
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.createFirstChannel") ||
                          "İlk kanalınızı oluşturmak için 'Kanal Ekle' butonuna tıklayın."
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showCreateModal = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("whatsappChannel.addChannel") || "Kanal Ekle"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.createChannel") || "Kanal Oluştur",
            footer: null,
            width: "500px",
          },
          model: {
            value: _vm.showCreateModal,
            callback: function ($$v) {
              _vm.showCreateModal = $$v
            },
            expression: "showCreateModal",
          },
        },
        [
          _c("CreateOpenRouterChannelForm", {
            attrs: { provider: _vm.provider },
            on: {
              ok: _vm.handleChannelCreated,
              cancel: function ($event) {
                _vm.showCreateModal = false
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("message.deleteConfirm") || "Kanalı Sil" },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.handleDeleteChannel },
                    },
                    [_vm._v(_vm._s(_vm.$t("chatbotv2.delete")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("message.deleteChannelConfirm") ||
                  "Bu kanalı silmek istediğinize emin misiniz?"
              )
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("cloud_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }